import api from "../services/api";
import { $Q } from '../utils/query-selector';
import { stringToHTML } from '../utils/to-html';
import initBestSellerSlider from "./best-sellers";
import { btnShowVariants } from "./product.modal";
import { btnAddToCart } from "./cart";
import { sliderUpsell } from './slider-swiper';
import { priceVat } from "./price-vat";
import { variantOnChange } from "../components/variants-product";

/**
 * Render recommendation by API with product ID
 * @return void
 */
async function getRecommendation(section) {
  const sectionToRender = $Q(section);

  if (!sectionToRender) return;

  const { items } = await api.read(`${routes.cart_url}.js`);

  let {
    dataset: {
      product,
      section: sectionName,
    },
  } = sectionToRender;

  if (items.length > 0) {
    product = items[0].product_id;
  }

  const params = {
    id: product,
    limit: 8,
    sectionId: sectionName,
  }

  const html = await api.getRecommendedProducts(params);

  const recommendation = $Q(section, stringToHTML(html));


  if (recommendation && recommendation.innerHTML.trim().length) {
    sectionToRender.innerHTML = recommendation.innerHTML;

    if (sectionName === "side-cart") {
      sliderUpsell();
    } else {
      initBestSellerSlider();
    }
    btnAddToCart('.upsell-recommendations-js .add-product-cart');
    btnAddToCart(".upsell-recommendations-js .add-product-cart-upsell");
    btnShowVariants('.upsell-recommendations-js .btn-show-variants-js');
    variantOnChange('.upsell-recommendations-js .variants')
    priceVat();
    var element = document.getElementsByClassName("trustpilot-widget");
    for (var i = 0; i < element.length; i++) {
      window.Trustpilot.loadFromElement(element[i]);
    }
  }
}

export function initRecommendation() {
  const arraySections = ["#upsell-js", "#best-sellers-recommendations"];

  arraySections.forEach(section => {
    getRecommendation(section);
  });
}

initRecommendation();
